import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const FormsAnalyticsCardIcon = ({
  className,
  ...props
}: HTMLAttributes<HTMLElement>) => (
  <i
    className={cn('absolute right-4 top-6 text-lg text-gray-600', className)}
    {...props}
  />
)
